module.exports = __webpack_public_path__ + "static/img/cinema.4a2e0e4e.png";